import { isActiveContract } from "@frontier/content/contract-orders";
import type { MissionView } from "@frontier/content/contracts";

export function navigationSource(
  mission: MissionView | null,
  savedFocus: string,
  trackedEventId: string | null,
): "contract" | "event" {
  return trackedEventId &&
    (!mission || savedFocus !== `${mission.runId}/${mission.orderId}`)
    ? "event"
    : "contract";
}

export function focusedMission(
  missions: readonly MissionView[],
  runId: string | undefined,
  savedFocus: string,
): MissionView | null {
  const current = missions.filter(
    (mission) => mission.runId === runId && isActiveContract(mission),
  );
  return (
    current.find(
      (mission) => `${mission.runId}/${mission.orderId}` === savedFocus,
    ) ??
    current[0] ??
    null
  );
}
